import { useState, useEffect } from 'react';
import { LARGE_BREAKPOINT_WIDTH } from '../constants';

/**
 * Custom hook to manage carousel state based on screen width
 * @returns {boolean} Whether carousel mode is enabled
 */
export function useCarousel() {
    const [carouselEnabled, setCarouselEnabled] = useState(window.innerWidth < LARGE_BREAKPOINT_WIDTH);

    useEffect(() => {
        const handleResize = () => {
            setCarouselEnabled(window.innerWidth < LARGE_BREAKPOINT_WIDTH);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return carouselEnabled;
}
